import React, { Component } from "react";
import {DurableFunctionInstance} from "../models/DurableFunctionInstance";
import moment from 'moment';
import DurationCellContent from "./DurationCellContent";

interface DurableFunctionInstanceDurationProps {
    durableFunctionInstance?: DurableFunctionInstance
    flex?: string | number;
}

interface DurableFunctionInstanceDurationState {

}

export default class DurableFunctionInstanceDuration extends Component<DurableFunctionInstanceDurationProps, DurableFunctionInstanceDurationState> {

    
    public render() {
        
        const flexClass = this.props.flex ? `flex-item--flex-${this.props.flex}` : "";

        if(!this.props.durableFunctionInstance)
        {
            return (
                <div className={`cdb-table__cell ${flexClass}`}>
                </div>
            );
        }
        
        const createdAt = moment(this.props.durableFunctionInstance.createdAt);
        const runtimeStatus = this.props.durableFunctionInstance.runtimeStatus;
        
        const lastUpdatedOrTimestamp = moment.max(moment(this.props.durableFunctionInstance.LastUpdatedTime),moment(this.props.durableFunctionInstance.Timestamp));
        const lastUpdatedOrNow = runtimeStatus === "Pending" || runtimeStatus === "Running" ? moment() : moment(lastUpdatedOrTimestamp);
        

        return (
            <div className={`cdb-table__cell ${flexClass}`}>
                <DurationCellContent from={createdAt} to={lastUpdatedOrNow}/>
            </div>
        );
        
    }
}